// GENERAL
export const BRDGE_PROJECT_ID = "postfinance" // can be any string, will be used to namespace cookies (so that two "brdge projects" seamlessly work without clearing cookies)

// LOCALES
export const AVAILABLE_LOCALES = ["de"]
export const DEFAULT_LOCALE = "de"

// MISC
export const WITH_DELAY = false
